const yellowhive = {
  primary: {
    main: '#FFD700', // Gold/yellow - primary color for buttons
    50: '#fffef0',
    100: '#fffce0',
    150: '#fffbd1',
    200: '#fff9c2',
    300: '#fff6a3',
    400: '#fff385',
    500: '#FFD700', // Main primary
    600: '#ffce00',
    700: '#cc9a00',
    750: '#b38700',
    800: '#997300',
    850: '#805f00',
    900: '#4d3900',
  },
  secondary: {
    main: '#1B3158', // Dark blue - secondary color
    '50': '#e6eaf2',
    '100': '#b3c0d6',
    '150': '#8fa1c1',
    '200': '#6b82ac',
    '300': '#476397',
    '400': '#32487c',
    '500': '#1B3158', // Main secondary
    '600': '#162947',
    '700': '#111f36',
    '750': '#0e192a',
    '800': '#0b1420',
    '850': '#090f19',
    '900': '#060912',
  },
};

export default yellowhive;
